import { memo, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import CommonSearchForm from '@/routes/components/common/common_searchForm';
import SelectLanguage from '@/routes/components/common/common_header_language';
import CommonSiteMap from '@/routes/components/common/common_siteMap';

import NavData from '@/config/data/nav/nav_data.json';
import useContent from '@/localization/data_export';

function MainHeader() {
  const { mode } = useSelector((state) => state);
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const header = useRef();

  const [scrollFlag, setScrollFlag] = useState(false);

  useEffect(() => {
    function throttle(callback, delay) {
      let timer = null;
      return () => {
        if (timer) return;
        timer = setTimeout(() => {
          callback();
          timer = null;
        }, delay);
      };
    }

    function updateScroll() {
      // :root { --top-banner-gov-h } = 35px
      const isScrolled = window.scrollY > 35;

      setScrollFlag(isScrolled);
    }

    window.addEventListener('scroll', throttle(updateScroll, 100));
    return () => {
      window.removeEventListener('scroll', throttle(updateScroll, 100));
    };
  }, []);

  useEffect(() => {
    if (header.current) scrollFlag ? header.current.classList.add('scroll') : header.current.classList.remove('scroll');
  }, [scrollFlag]);

  return (
    <header id="CommonHeader" className="header home" ref={header}>
      <div className="header_container">
        <div className="header_container_content">
          <h1 className="header_container_logo">
            <Link to={NavData['HOME'].path} title={anchorTitle}>
              <img className="headerLogo" src={require('@/assets/images/layout/logo_header_red.png').default} alt="" />
            </Link>
          </h1>
          <div className="header_container_gnb">
            <ul className="gnb">
              <li className="gnb_dp1">
                <Link to={NavData['LIVE_MAIN'].path} className="gnb_link" title={anchorTitle}>
                  LIVE
                </Link>
              </li>
              <li className="gnb_dp1 news">
                <Link to={NavData['NEWS_MAIN'].path} className="gnb_link gnb_link_news" title={anchorTitle}>
                  NEWS
                </Link>
              </li>
              <li className="gnb_dp1 tv">
                <Link to={NavData['TV_MAIN'].path} className="gnb_link" title={anchorTitle}>
                  TV
                </Link>
              </li>
              <li className="gnb_dp1">
                <Link to={NavData['RADIO_MAIN'].path} className="gnb_link" title={anchorTitle}>
                  RADIO
                </Link>
              </li>
              <li className="gnb_dp1 vod">
                <Link to={NavData['VOD_MAIN'].path} className="gnb_link" title={anchorTitle}>
                  VOD
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="header_container_subGnb">
          <ul className="subGnb">
            <li className="subGnb_dp1_list">
              <a
                href={`https://company.arirang.com/?lang=${mode}`}
                className="subGnb_link"
                target="_blank"
                rel="noreferrer"
                title={anchorTitle}
              >
                {mode === 'ko' ? '재단소개' : 'About Arirang'}
              </a>
            </li>
            <li className="subGnb_dp1_list">
              <Link to={NavData['SCHEDULE'].path} className="subGnb_link" title={anchorTitle}>
                {mode === 'ko' ? '편성표' : 'SCHEDULE'}
              </Link>
            </li>
            <li className="subGnb_dp1_list">
              <Link to="/" className="subGnb_link headerLangIco" title={anchorTitle}>
                {mode === 'ko' ? '언어' : 'LANGUAGE'}
              </Link>
              <SelectLanguage />
            </li>
            <li className="subGnb_dp1_list search-btn">
              <CommonSearchForm className="header-search--size-small" />
            </li>
            <li className="subGnb_dp1_list btnSiteMap-wrap">
              <CommonSiteMap />
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}
export default memo(MainHeader);
